import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Hero from './components/Hero';
import Advantages from './components/Advantages';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import Fleet from './components/Fleet';
import Gallery from './components/Gallery';
import Benefits from './components/Benefits';
import Destinations from './components/Destinations';
import PopularRoutes from './components/PopularRoutes';
import BlogTeaser from './components/BlogTeaser';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Stats from './components/Stats';
import Footer from './components/Footer';
import PageTranslator from './components/PageTranslator';
import SiteSchema from './components/SiteSchema';
import PathNormalizer from './components/PathNormalizer';
import useSEO from './hooks/useSEO';
import WhatsAppButton from './components/WhatsAppButton';
import FleetPage from './pages/FleetPage';
import BlogList from './pages/BlogList';
import BlogArticle from './pages/BlogArticle';
import CityPage from './pages/CityPage';
import CitiesIndex from './pages/CitiesIndex';
import AdminDashboard from './pages/AdminDashboard';
import BookingPage from './pages/BookingPage';
import PricesPage from './pages/PricesPage';
import DriverPortal from './pages/DriverPortal';
import StaticPage from './pages/StaticPage';
import FaqPage from './pages/FaqPage';
import GuidePage from './pages/GuidePage';
import KeywordPage from './pages/KeywordPage';
import TransfersIndex from './pages/TransfersIndex';
import PaymentResult from './pages/PaymentResult';
import NotFound from './pages/NotFound';

const Home = () => {
  useSEO('CAB.TAXI | Airport Taxi & Transfer Zürich – Festpreis', 'Flughafentaxi & Transfer Zürich zum Festpreis. Flugverfolgung, Meet & Greet, 24/7 – Zürich (ZRH), Basel (BSL), Genf (GVA) und die ganze Schweiz.');
  return (
  <>
    <Header />
    <main>
      <Hero />
      <Advantages />
      <HowItWorks />
      <Services />
      <Fleet />
      <Gallery />
      <Benefits />
      <Destinations />
      <PopularRoutes />
      <Testimonials />
      <FAQ />
      <BlogTeaser />
      <Stats />
    </main>
    <Footer />
    <WhatsAppButton />
  </>
  );
};

function App() {
  return (
    <AppProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/fleet" element={<FleetPage />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/cities" element={<CitiesIndex />} />
            <Route path="/taxi/:slug" element={<CityPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/payment-result" element={<PaymentResult />} />
            <Route path="/prices" element={<PricesPage />} />
            <Route path="/driver" element={<DriverPortal />} />
            <Route path="/about" element={<StaticPage slugProp="about" />} />
            <Route path="/contact" element={<StaticPage slugProp="contact" />} />
            <Route path="/help" element={<StaticPage slugProp="help" />} />
            <Route path="/careers" element={<StaticPage slugProp="careers" />} />
            <Route path="/terms" element={<StaticPage slugProp="terms" />} />
            <Route path="/privacy" element={<StaticPage slugProp="privacy" />} />
            <Route path="/cookies" element={<StaticPage slugProp="cookies" />} />
            <Route path="/refund" element={<StaticPage slugProp="refund" />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/guide/:slug" element={<GuidePage />} />
            <Route path="/transfers" element={<TransfersIndex />} />
            <Route path="/t/:slug" element={<KeywordPage />} />
            <Route path="/:lang/transfers" element={<TransfersIndex />} />
            <Route path="/:lang/t/:slug" element={<KeywordPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <PageTranslator />
          <SiteSchema />
          <PathNormalizer />
        </BrowserRouter>
        <Toaster />
      </div>
    </AppProvider>
  );
}

export default App;
